import React, { useRef, useState } from "react";
import { Modal, Button, Input } from "antd";
import { KeyOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";

import Modalnewpass from "./modalNewPassword";
import { actionCodigo } from "../../redux/actions/login/login";
import { notify } from "../ui";

function Home({ show, setShow, clave, correo }) {
  const [code, setCode] = useState("");
  const [showpass, setShowpass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const close = () => {
    if (loading) return;
    setShow(false);
  };

  const submit = async (e) => {
    e?.preventDefault?.();

    const codeValue = (code || "").trim();
    if (!codeValue) {
      setError("El código es obligatorio.");
      return;
    }
    if (codeValue.length > 10) {
      setError("El código no puede exceder 10 caracteres.");
      return;
    }
    setError("");
    setLoading(true);

    const parametros = { clave, code: codeValue, email: correo };

    dispatch(
      actionCodigo(
        parametros,
        (value) => {
          setLoading(false);

          if (value?.status) {
            setShow(false);
            setShowpass(true);
            return;
          }

          notify.error("Código inválido", "Verifica el código e inténtalo de nuevo.");
        },
        (err) => {
          setLoading(false);
          notify.error(
            "No se pudo validar",
            typeof err === "string" ? err : "Ocurrió un error al validar el código."
          );
        }
      )
    );
  };

  return (
    <>
      <Modalnewpass show={showpass} setShow={setShowpass} correo={correo} code={code} />

      <Modal
        open={show}
        onCancel={close}
        centered
        maskClosable={!loading}
        closable={!loading}
        title={
          <div className="d-flex align-items-start gap-3">
            <div
              className="rounded-3 bg-primary-subtle d-flex align-items-center justify-content-center"
              style={{ width: 40, height: 40, flexShrink: 0 }}
            >
              <i className="bi bi-shield-lock fs-5" />
            </div>
            <div>
              <div className="mb-1">Verificación de seguridad</div>
              <p className="text-secondary mb-1" style={{ fontWeight: 400 }}>
                Ingresa el código que se envió a tu correo para continuar.
              </p>
              <small className="text-secondary">
                Correo: <strong>{correo || "-"}</strong>
              </small>
            </div>
          </div>
        }
        footer={[
          <Button key="cancel" onClick={close} disabled={loading}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={submit}>
            Validar
          </Button>,
        ]}
      >
        <form onSubmit={submit}>
          <div className="mb-2">
            <label className="d-block mb-1">Código</label>
            <Input
              ref={inputRef}
              size="large"
              prefix={<KeyOutlined />}
              placeholder="Ej. 123456"
              maxLength={10}
              autoFocus
              disabled={loading}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              status={error ? "error" : ""}
              style={{ letterSpacing: 1 }}
            />
            {error && <div className="text-danger small mt-1">{error}</div>}
          </div>
          <small className="text-secondary">
            Si no recibiste el código, revisa spam o solicita un reenvío desde la pantalla anterior.
          </small>
        </form>
      </Modal>
    </>
  );
}

export default Home;
